/*
 * Kunstmühle Hofmeir – Merkliste: Herz auf Produktkarten und Produktseite, Herz im Header,
 * Drawer von rechts (snippets/km-wishlist-drawer.liquid). Gespeichert im Browser unter „km-wishlist“:
 * [{ handle, id, v (gewählte Variante, optional), ts }]. Preise und Verfügbarkeit kommen beim Öffnen
 * frisch aus /products/<handle>.js. In den Warenkorb über window.kmAddItems (km-relaunch.js).
 * Merkliste im Kundenkonto (Einstellung km_wishlist_account): angemeldet zusätzlich beim Kunden gespeichert,
 * über den App-Proxy der App „Kunstmühle“ (<proxy>/merkliste, Repo kunstmuehle-app).
 * Statistik (Einstellung km_wishlist_stats, data-statistik am Drawer): anonym gemerkt / entfernt / in den Warenkorb
 * per sendBeacon an <proxy>/merkliste-statistik – mit data-statistik-zustimmung (Einstellung km_wishlist_stats_consent)
 * nur mit Zustimmung zu Statistik im Cookie-Banner, sonst immer. Dazu meldet ein
 * Browser ohne Konto-Merkliste seine aktuelle Liste (nur Handles) mit einer Zufallskennung „km-wishlist-id“ – bei jeder
 * Änderung und spätestens alle 7 Tage; angemeldet mit Konto-Merkliste zählt das Konto, der Browser meldet sich ab.
 */
(function () {
  const KEY = 'km-wishlist';
  const MAX = 100;

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list.filter((i) => i && typeof i.handle === 'string' && i.handle) : [];
    } catch (e) {
      return [];
    }
  };
  let list = read();

  const notify = () => document.dispatchEvent(new CustomEvent('km:wishlist', { detail: { count: list.length } }));
  let changed = () => {}; // Kundenkonto-Abgleich hängt sich hier ein
  const write = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    notify();
    changed();
  };
  const has = (handle) => list.some((i) => i.handle === handle);

  const wishlist = {
    list: () => list.slice(),
    has,
    add(entry) {
      if (has(entry.handle)) return;
      list = [{ ...entry, ts: Date.now() }, ...list].slice(0, MAX);
      write();
    },
    remove(handle) {
      list = list.filter((i) => i.handle !== handle);
      write();
    },
    setVariant(handle, variantId) {
      const entry = list.find((i) => i.handle === handle);
      if (!entry || entry.v === variantId) return;
      entry.v = variantId;
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
      changed();
    },
  };
  window.kmWishlist = wishlist;

  // Kundenkonto: Beim ersten Abgleich der Sitzung gilt die Liste im Konto; ergänzt wird, was seit dem letzten
  // Abgleich im Browser dazukam (z. B. als Gast gemerkt). Danach wird jede Änderung ins Konto geschrieben.
  const drawerEl = document.getElementById('KmWishlist');

  // Anonyme Statistik für die App (Seite „Merkliste“): nur Ereignis und Produkt-Handle, keine Kundendaten
  const statUrl = drawerEl?.dataset.statistik || '';
  const statZustimmung = drawerEl?.dataset.statistikZustimmung === '1';
  let consentLoad = null;
  const consent = () => {
    if (!statZustimmung) return Promise.resolve(true);
    const allowed = () => {
      try {
        return !!window.Shopify.customerPrivacy.analyticsProcessingAllowed();
      } catch (e) {
        return false;
      }
    };
    if (window.Shopify?.customerPrivacy) return Promise.resolve(allowed());
    if (!window.Shopify?.loadFeatures) return Promise.resolve(false);
    consentLoad ||= new Promise((r) => window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => r()));
    return consentLoad.then(allowed);
  };
  const track = (ev) => {
    if (!statUrl) return;
    consent().then((ok) => {
      if (!ok) return;
      const body = JSON.stringify(ev);
      let sent = false;
      try {
        sent = !!navigator.sendBeacon?.(statUrl, new Blob([body], { type: 'text/plain' }));
      } catch (e) {}
      if (!sent) fetch(statUrl, { method: 'POST', body, keepalive: true, credentials: 'same-origin', headers: { 'Content-Type': 'text/plain' } }).catch(() => {});
    });
  };
  const kunde = drawerEl?.dataset.konto || '';
  const proxy = drawerEl?.dataset.proxy || '';

  // Merkliste ohne Kundenkonto für die Statistik melden (Kennung entsteht erst, wenn gemeldet werden darf)
  const STAT_KEY = 'km-wishlist-stat'; // { sig, ts }: zuletzt gemeldete Liste
  let statTimer = null;
  const meldeListe = () => {
    if (!statUrl) return;
    clearTimeout(statTimer);
    statTimer = setTimeout(() => {
      consent().then((ok) => {
        if (!ok) return;
        try {
          const handles = kunde ? [] : list.map((i) => i.handle).slice(0, MAX);
          const sig = JSON.stringify(handles);
          const alt = JSON.parse(localStorage.getItem(STAT_KEY)) || {};
          if (!handles.length && (!alt.sig || alt.sig === '[]')) return;
          if (alt.sig === sig && Date.now() - (alt.ts || 0) < 7 * 864e5) return;
          let id = localStorage.getItem('km-wishlist-id');
          if (!/^[a-z0-9-]{16,40}$/.test(id || '')) {
            id = crypto.randomUUID ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, '0')).join('');
            localStorage.setItem('km-wishlist-id', id);
          }
          track({ e: 'liste', id, h: handles });
          localStorage.setItem(STAT_KEY, JSON.stringify({ sig, ts: Date.now() }));
        } catch (e) {}
      });
    }, 1500);
  };
  document.addEventListener('km:wishlist', meldeListe);
  document.addEventListener('visitorConsentCollected', meldeListe); // Zustimmung im Banner während des Besuchs
  meldeListe();
  if (kunde && proxy) {
    const SYNC_KEY = 'km-wishlist-konto'; // { kunde, ts }: letzter erfolgreicher Abgleich auf diesem Gerät
    const endpoint = `${proxy.replace(/\/$/, '')}/merkliste`;
    const readSync = () => {
      try {
        return JSON.parse(localStorage.getItem(SYNC_KEY)) || {};
      } catch (e) {
        return {};
      }
    };
    const markSynced = () => {
      try {
        localStorage.setItem(SYNC_KEY, JSON.stringify({ kunde, ts: Date.now() }));
        sessionStorage.setItem(SYNC_KEY, kunde);
      } catch (e) {}
    };
    const key = (items) => JSON.stringify(items.map((i) => [i.handle, i.v || null]));
    const same = (a, b) => key(a) === key(b);

    let timer = null;
    const save = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetch(endpoint, {
          method: 'PUT',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: list }),
        })
          .then((r) => r.ok && markSynced())
          .catch(() => {});
      }, 600);
    };

    const merge = (server) => {
      const sync = readSync();
      // Erstes Mal auf diesem Gerät: ganze Browser-Liste übernehmen; anderes Konto zuletzt: nichts übernehmen
      const local = !sync.kunde ? list : sync.kunde === kunde ? list.filter((i) => (i.ts || 0) > (sync.ts || 0)) : [];
      const known = new Set(server.map((i) => i.handle));
      return [...local.filter((i) => !known.has(i.handle)), ...server]
        .sort((a, b) => (b.ts || 0) - (a.ts || 0))
        .slice(0, MAX);
    };

    // Änderungen erst nach dem Abgleich ins Konto schreiben – vorher Gemerktes wird beim Abgleich ergänzt
    const start = () => {
      let done = false;
      try {
        done = sessionStorage.getItem(SYNC_KEY) === kunde;
      } catch (e) {}
      if (done) {
        changed = save;
        return;
      }
      fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (!data || !Array.isArray(data.items)) return;
          changed = save;
          const merged = merge(data.items);
          if (!same(merged, list)) {
            list = merged;
            try {
              localStorage.setItem(KEY, JSON.stringify(list));
            } catch (e) {}
            notify();
          }
          if (same(merged, data.items)) markSynced();
          else save();
        })
        .catch(() => {});
    };
    start();
  }

  // Andere Tabs halten die Liste aktuell
  window.addEventListener('storage', (event) => {
    if (event.key !== KEY) return;
    list = read();
    notify();
  });

  const announce = (text) => {
    const live = document.getElementById('KmWishlist-Live');
    if (!live) return;
    live.textContent = '';
    setTimeout(() => (live.textContent = text), 50);
  };

  const fmtMoney = (cents) =>
    (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
  const sizedImage = (src, width) => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) {
      return '';
    }
  };

  // Header: Anzahl am Herz
  const updateCount = () => {
    document.querySelectorAll('[data-km-wish-count]').forEach((bubble) => {
      bubble.hidden = list.length === 0;
      const span = bubble.querySelector('span') || bubble;
      span.textContent = list.length < 100 ? String(list.length) : '99+';
    });
    document.querySelectorAll('[data-km-wish-open]').forEach((button) => {
      button.setAttribute('aria-label', list.length ? `Merkliste (${list.length})` : 'Merkliste');
    });
  };
  document.addEventListener('km:wishlist', updateCount);

  class KmWishButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      if (!this.kmBound) {
        this.kmBound = true;
        this.sync = () => this.render();
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        });
      }
      document.addEventListener('km:wishlist', this.sync);
      this.render();
    }

    disconnectedCallback() {
      if (this.sync) document.removeEventListener('km:wishlist', this.sync);
    }

    render() {
      const on = has(this.dataset.handle);
      this.button.setAttribute('aria-pressed', on ? 'true' : 'false');
      this.classList.toggle('is-active', on);
    }

    // Produktseite: die gerade gewählte Packungsgröße mit merken
    currentVariant() {
      if (this.dataset.context !== 'product') return null;
      const scope = this.closest('product-info, .product, section') || document;
      const input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      return input ? Number(input.value) || null : null;
    }

    toggle() {
      const handle = this.dataset.handle;
      const title = this.dataset.title || 'Produkt';
      if (has(handle)) {
        wishlist.remove(handle);
        track({ e: 'entfernen', h: handle });
        announce(`${title} von der Merkliste entfernt`);
        return;
      }
      wishlist.add({ handle, id: Number(this.dataset.productId) || null, v: this.currentVariant() });
      track({ e: 'merken', h: handle });
      announce(`${title} gemerkt`);
      this.classList.remove('is-pop');
      void this.offsetWidth;
      this.classList.add('is-pop');
      document.querySelectorAll('[data-km-wish-open]').forEach((el) => {
        el.classList.remove('is-pop');
        void el.offsetWidth;
        el.classList.add('is-pop');
      });
    }
  }
  if (!customElements.get('km-wish-button')) customElements.define('km-wish-button', KmWishButton);

  class KmWishlistDrawer extends HTMLElement {
    connectedCallback() {
      if (this.kmBound) return;
      this.kmBound = true;
      this.listEl = this.querySelector('[data-km-wish-list]');
      this.emptyEl = this.querySelector('[data-km-wish-empty]');
      this.footerEl = this.querySelector('[data-km-wish-footer]');
      this.statusEl = this.querySelector('[data-km-wish-status]');
      this.products = new Map();
      this.renderToken = 0;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-km-wish-close]')) return this.close();
        const remove = event.target.closest('[data-km-wish-remove]');
        if (remove) {
          const item = remove.closest('[data-km-wish-item]');
          wishlist.remove(item.dataset.handle);
          track({ e: 'entfernen', h: item.dataset.handle });
          announce(`${item.dataset.title} von der Merkliste entfernt`);
          return;
        }
        const add = event.target.closest('[data-km-wish-add]');
        if (add) return this.add([add.closest('[data-km-wish-item]')], add);
        const all = event.target.closest('[data-km-wish-add-all]');
        if (all) return this.add(Array.from(this.querySelectorAll('[data-km-wish-item]')), all);
      });
      this.addEventListener('change', (event) => {
        const select = event.target.closest('[data-km-wish-variant]');
        if (!select) return;
        const item = select.closest('[data-km-wish-item]');
        wishlist.setVariant(item.dataset.handle, Number(select.value));
        this.updatePrice(item);
      });
      document.addEventListener('keyup', (event) => event.code === 'Escape' && this.isOpen && this.close());
      document.addEventListener('km:wishlist', () => this.isOpen && this.render());
      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-km-wish-open]');
        if (!opener) return;
        event.preventDefault();
        this.open(opener);
      });
    }

    open(trigger) {
      this.trigger = trigger || null;
      this.isOpen = true;
      this.statusEl.textContent = '';
      this.render();
      document.documentElement.classList.add('km-wish-open');
      document.querySelectorAll('[data-km-wish-open]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => this.classList.add('active'));
      const inner = this.querySelector('.drawer-inner');
      inner.addEventListener(
        'transitionend',
        () => {
          if (this.isOpen && typeof trapFocus === 'function') trapFocus(inner, this.querySelector('.drawer-close'));
        },
        { once: true }
      );
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('active');
      document.documentElement.classList.remove('km-wish-open');
      document.querySelectorAll('[data-km-wish-open]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.trigger);
      else if (this.trigger) this.trigger.focus();
    }

    // false = Produkt gibt es nicht mehr, null = gerade nicht erreichbar
    fetchProduct(handle) {
      if (!this.products.has(handle)) {
        const root = window.Shopify?.routes?.root || '/';
        const request = fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
          .then((r) => (r.status === 404 ? false : r.ok ? r.json() : null))
          .catch(() => null);
        this.products.set(handle, request);
        // Preise nicht ewig zwischenspeichern
        request.then(() => setTimeout(() => this.products.delete(handle), 5 * 60 * 1000));
      }
      return this.products.get(handle);
    }

    async render() {
      const entries = wishlist.list();
      const token = ++this.renderToken;
      this.emptyEl.hidden = entries.length > 0;
      this.footerEl.hidden = entries.length === 0;
      if (!entries.length) {
        this.listEl.replaceChildren();
        return;
      }
      this.listEl.setAttribute('aria-busy', 'true');
      const products = await Promise.all(entries.map((entry) => this.fetchProduct(entry.handle)));
      if (token !== this.renderToken) return;
      this.listEl.removeAttribute('aria-busy');

      const gone = entries.filter((entry, i) => products[i] === false);
      const items = entries
        .map((entry, i) => (products[i] ? this.buildItem(entry, products[i]) : null))
        .filter(Boolean);
      const hadFocus = this.contains(document.activeElement);
      this.listEl.replaceChildren(...items);
      // Entfernter Artikel hatte den Fokus: im Drawer bleiben
      if (this.isOpen && hadFocus && !this.contains(document.activeElement)) this.querySelector('.drawer-inner').focus();
      const buyable = items.some((item) => !item.querySelector('[data-km-wish-add]').disabled);
      this.querySelector('[data-km-wish-add-all]').hidden = !buyable || items.length < 2;
      // Gelöschte Produkte still aus der Liste nehmen (löst ein neues render aus)
      gone.forEach((entry) => wishlist.remove(entry.handle));
    }

    buildItem(entry, product) {
      // Packungsgrößen aufsteigend (1 kg, 2,5 kg, 5 kg), egal wie sie im Admin sortiert sind
      const variants = (product.variants || []).slice().sort((a, b) => (a.weight || 0) - (b.weight || 0));
      const available = variants.filter((v) => v.available);
      const preferred =
        available.find((v) => v.id === entry.v) || available[0] || variants.find((v) => v.id === entry.v) || variants[0];
      const onlyDefault = variants.length === 1 && /^default title$/i.test(variants[0].title || '');

      const li = document.createElement('li');
      li.className = 'km-wish__item';
      li.dataset.kmWishItem = '';
      li.dataset.handle = entry.handle;
      li.dataset.title = product.title;
      li.variants = variants;

      const media = document.createElement('a');
      media.className = 'km-wish__media';
      media.href = product.url;
      media.tabIndex = -1;
      media.setAttribute('aria-hidden', 'true');
      const image = (preferred && preferred.featured_image && preferred.featured_image.src) || product.featured_image;
      if (image) {
        const img = document.createElement('img');
        img.src = sizedImage(image, 160);
        img.alt = '';
        img.width = 72;
        img.height = 72;
        img.loading = 'lazy';
        media.append(img);
      }

      const info = document.createElement('div');
      info.className = 'km-wish__info';
      const name = document.createElement('a');
      name.className = 'km-wish__name';
      name.href = product.url;
      name.textContent = product.title;
      info.append(name);

      if (!onlyDefault && variants.length > 1) {
        const select = document.createElement('select');
        select.className = 'km-wish__variant';
        select.dataset.kmWishVariant = '';
        select.setAttribute('aria-label', `Packungsgröße für ${product.title}`);
        variants.forEach((v) => {
          const option = document.createElement('option');
          option.value = String(v.id);
          option.textContent = v.available ? v.title : `${v.title} – nicht vorrätig`;
          option.disabled = !v.available;
          option.selected = preferred && v.id === preferred.id;
          select.append(option);
        });
        info.append(select);
      } else if (!onlyDefault && preferred) {
        const size = document.createElement('span');
        size.className = 'km-wish__size';
        size.textContent = preferred.title;
        info.append(size);
      }
      const price = document.createElement('span');
      price.className = 'km-wish__price';
      price.dataset.kmWishPrice = '';
      const unit = document.createElement('span');
      unit.className = 'km-wish__unit';
      unit.dataset.kmWishUnit = '';
      info.append(price, unit);

      const actions = document.createElement('div');
      actions.className = 'km-wish__actions';
      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'km-wish__add';
      add.dataset.kmWishAdd = '';
      add.dataset.variantId = preferred ? String(preferred.id) : '';
      add.textContent = 'In den Warenkorb';
      add.disabled = !available.length;
      if (!available.length) add.textContent = 'Nicht vorrätig';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'km-wish__remove';
      remove.dataset.kmWishRemove = '';
      remove.setAttribute('aria-label', `${product.title} von der Merkliste entfernen`);
      const heart = this.querySelector('template[data-km-wish-heart]');
      if (heart) remove.append(heart.content.cloneNode(true));
      actions.append(add, remove);

      li.append(media, info, actions);
      this.updatePrice(li);
      return li;
    }

    selectedVariant(item) {
      const select = item.querySelector('[data-km-wish-variant]');
      const id = select ? Number(select.value) : Number(item.querySelector('[data-km-wish-add]').dataset.variantId);
      return (item.variants || []).find((v) => v.id === id) || null;
    }

    updatePrice(item) {
      const variant = this.selectedVariant(item);
      const price = item.querySelector('[data-km-wish-price]');
      if (!price) return;
      price.textContent = variant ? fmtMoney(variant.price) : '';
      if (variant && variant.compare_at_price > variant.price) {
        const old = document.createElement('s');
        old.textContent = fmtMoney(variant.compare_at_price);
        price.append(' ', old);
      }
      // Grundpreis wie in snippets/price.liquid: nur, wenn er vom Preis abweicht
      const unit = item.querySelector('[data-km-wish-unit]');
      const m = variant && variant.unit_price_measurement;
      unit.textContent =
        m && variant.unit_price != null && variant.unit_price !== variant.price
          ? `${fmtMoney(variant.unit_price)} / ${m.reference_value !== 1 ? m.reference_value + ' ' : ''}${m.reference_unit}`
          : '';
      const add = item.querySelector('[data-km-wish-add]');
      if (variant) add.dataset.variantId = String(variant.id);
    }

    async add(items, button) {
      const lines = items
        .map((item) => {
          const variant = this.selectedVariant(item);
          if (!variant || !variant.available) return null;
          const onlyDefault = /^default title$/i.test(variant.title || '');
          return { id: variant.id, q: 1, t: item.dataset.title, v: onlyDefault ? '' : variant.title };
        })
        .filter(Boolean);
      if (!lines.length || typeof window.kmAddItems !== 'function') return;
      button.disabled = true;
      button.classList.add('loading');
      this.statusEl.textContent = '';
      const result = await window.kmAddItems(lines, { source: 'km-wishlist' });
      button.disabled = false;
      button.classList.remove('loading');
      if (result.added) {
        track({ e: 'warenkorb', n: lines.length });
        // Merkliste zu, Warenkorb-Drawer ist schon offen
        this.close();
      } else if (result.missing) {
        this.statusEl.textContent = `Gerade nicht verfügbar: ${result.missing}`;
      }
    }
  }
  if (!customElements.get('km-wishlist-drawer')) customElements.define('km-wishlist-drawer', KmWishlistDrawer);

  updateCount();
})();
